import React, { Fragment } from "react";
import { withCookies } from "react-cookie";
import { connect } from "react-redux";
import { Route, withRouter, Switch, Redirect } from "react-router-dom";
import { get_auth, login_fail } from "./actions/auth";
import "./App.css";
import AdminCreateProducts from "./components/admin/AdminCreateProducts";
import AdminEditProducts from "./components/admin/AdminEditProducts";
import AdminLoginMsg from "./components/admin/AdminLoginMsg";
import AdminOrder from "./components/admin/AdminOrder";
import AdminProducts from "./components/admin/AdminProducts";
import AdminSale from "./components/admin/AdminSale";
import AdminSaleDetail from "./components/admin/AdminSaleDetail";
import AdminSaleProducts from "./components/admin/AdminSaleProducts";
import Header from "./header/Header";

const NotFound = () => (
  <div style={{ textAlign: "center", marginTop: "50px" }}>
    <h1>This page is not supported.</h1>
    <p>
      A plan subscription is required to use "Musio Forever".
      Please contact us <a href="mailto:info-jp@akaintelligence.com">info-jp@akaintelligence.com</a> to sign up for the plan.
    </p>
  </div>
);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      header: null,
    };

    if (this.props.jwt === undefined) {
      let session_token = this.props.cookies.cookies.session_token;
      // let session_token=""; //for test, you can use session token for production service
      if (
        session_token !== undefined &&
        session_token !== null &&
        session_token !== "None"
      ) {
        this.props.getToken(session_token);
      } else {
        this.props.loginFail();
      }
    }
  }

  render() {
    const pathname = (this.props.location && this.props.location.pathname) || "";
    const isAdminPath = pathname.includes("admin");
    const isAuthed = this.props.jwt !== undefined;

    return (
      <Switch>
        {isAdminPath ? (
          isAuthed ? (
            <>
              <Fragment>
                <Route exact path="/adminProductPost" component={AdminCreateProducts} />
                <Route exact path="/adminProduct" component={AdminProducts} />
                <Route exact path="/adminProductEdit/:product_id" component={AdminEditProducts} />
                <Route exact path="/adminOrder" component={AdminOrder} />
                <Route exact path="/adminSale" component={AdminSale} />
                <Route exact path="/adminSaleProducts" component={AdminSaleProducts} />
                <Route exact path="/adminSaleProducts/:product_id" component={AdminSaleDetail} />

                <Route path="/admin" render={() => <Redirect to="/" />} />
              </Fragment>
            </>
          ) : (
            <>
              <Header />
              <Fragment>
                <Route path="/admin" component={AdminLoginMsg} />
              </Fragment>
            </>
          )
        ) : (
          <Route component={NotFound} />
        )}
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    jwt: state.AuthReducer.jwt,
    isAuthenticated: state.AuthReducer.isAuthenticated,
    pending: state.AuthReducer.pending,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getToken: (session_token) => dispatch(get_auth(session_token)),
    loginFail: () => dispatch(login_fail()),
  };
};

export default withRouter(
  withCookies(connect(mapStateToProps, mapDispatchToProps)(App))
);
